'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
}; /*!
    * translator <https://github.com/derzunov/translator>
    *
    * Copyright (c) 2018, Dmitry Erzunov.
    * Licensed under the MIT License.
    */

var _pluralizr = require('pluralizr');
var _pluralizr2 = _interopRequireDefault(_pluralizr);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ERROR_STRING = '!!! i18n Error !!!';
var getValue = function getValue(currentLangDictionary, key) {
  if (key in currentLangDictionary) {
    return currentLangDictionary[key];
  }
  var keys = key.split('.');
  var value = currentLangDictionary;
  while (keys.length > 0) {
    key = keys.shift();
    value = value[key];
    if (value === undefined) break;
  }
  return value;
};
var pluralLocalize = function pluralLocalize(languageCode, pluralStrings, numbers) {
  var number = numbers[0];
  switch (typeof pluralStrings === 'undefined' ? 'undefined' : _typeof(pluralStrings)) {
    case 'string':
      var match = pluralStrings.match(/\[(.*?\])\s*\]/g);
      if (match) {
        match.forEach(function (matchData) {
          var pluralMatch = matchData.match(/\[.*(\[(.*?)\])\s*\]/);
          var pluralObject = pluralMatch[2].split(',').map(function (text) {
            return text.replace(/\'|\"|\s+/g, '');
          });
          var pluralArray = pluralMatch[0].split(',');
          var count = pluralArray[0].replace(/\[|\s+|\"|\'/g, '');
          var separator = pluralArray[1].match(/\'([^\']*)\'|\"([^\"]*)/)[2];
          pluralStrings = pluralStrings.replace(matchData, pluralLocalize(languageCode, [count, separator, pluralObject], [numbers.shift()]));
        });
      }

      // If no need in forms, but we want to replace "$Count" with number
      return pluralStrings.replace('$Count', number);
    case 'object':
      if (typeof pluralStrings.reduce !== 'function') {
        console.error('i18n: the value of the key is an object. Expected values: string or array');
        return ERROR_STRING;
      }
      return pluralStrings.reduce(function (result, piece) {
        switch (typeof piece === 'undefined' ? 'undefined' : _typeof(piece)) {
          case 'string':
            var isVariable = piece.indexOf('$') === 0;
            result += isVariable ? number : piece;
            break;
          case 'object':
            if (piece.length != null) {
              result += (0, _pluralizr2.default)(languageCode, number, piece);
            }
            break;
          default:
          //do nothing
        }
        return result;
      }, '');
    default:
      console.error('i18n: The key passed into PluralLocalize is not a string or array. Language code ' + languageCode + ', value of key: ' + pluralStrings);
      return ERROR_STRING;
  }
};
var translate = function translate(currentLangDictionary, languageCode, key) {
  if (languageCode === 'keys') {
    return key; // If we want to see keys without translate
  }
  if (!currentLangDictionary) {
    console.error('i18n: translate: no dictionary');
    return ERROR_STRING;
  }
  var value = getValue(currentLangDictionary, key);
  if (value) {
    for (var _len = arguments.length, numbers = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      numbers[_key - 3] = arguments[_key];
    }
    if (numbers && numbers.length > 0) {
      // Use pluralize mechanics
      return pluralLocalize(languageCode, value, numbers);
    } else {
      // Just take a string from dictionary
      return value;
    }
  } else {
    console.error('i18n: No value for key ' + key + ' in dictionary', currentLangDictionary);
    return ERROR_STRING;
  }
};
exports.default = translate;